import { useEffect, useState } from "react";
import { useRecordContext } from "react-admin";

/*
This handles numbers, strings, arrays, and objects.

E.g.
<TabCount source="users" />

users.0.communities will return the # of communities for the first user
coordinating_program.users will return the # of users in the coordinating program
etc.

fallback={<></>} can also be provided
*/

export function TabCount(props) {
    const record = useRecordContext();
    const [count, setCount] = useState(0);

    useEffect(() => {
        let split = props.source.split('.');
        let refObj = record;
        let _count = props.fallback ?? 0;
        for(let splitVal of split) {
            try {
                refObj = refObj[splitVal];
            } catch(e) {
                refObj = null;
                break;
            }
        }

        if(refObj == null) {
            // do nothing for null
        } else if(typeof refObj === 'number') {
            // nunmbers
            _count = refObj;
        } else if(refObj.hasOwnProperty('length')) {
            // arrays and strings
            _count = refObj.length;
        } else if(typeof refObj === 'object') {
            // objects
            _count = Object.keys(refObj);
        }
        setCount(_count);
    }, [record]);

    return <>{count}</>;
}
